import { dealEventLogControllerGetDealEventRecipientsOptions } from '@dealstack/shared/lib/backendClient/@tanstack/react-query.gen';
import { useDealEventPeopleFilter } from '@dealstack/frontend/app/pages/Project/DealEventLog/useDealEventPeopleFilter.ts';

const page = (
	data: { recipients?: { name?: string; email: string }[]; hasMore?: boolean } | undefined
) => ({
	people: data?.recipients ?? [],
	hasMore: !!data?.hasMore,
});

// The address is what the feed filters on; the name is what the list shows, and is only missing
// when a send was never linked to a person.
const toValue = ({ email }: { email: string }) => email;

export const useDealEventRecipients = (dealId: string, enabled: boolean, selected?: string) =>
	useDealEventPeopleFilter({
		dealId,
		enabled,
		selected,
		queryOptions: dealEventLogControllerGetDealEventRecipientsOptions,
		page,
		toValue,
	});
